export enum AvailablePeriodType {
  HOURLY = "hourly", DAY = "day", WEEK = "week", MONTH = "month", YEAR = "year", COMPARATIVE = "comparative"
}
